import { lazy } from "react";
import { AuthenticatedHomeRedirect, AuthenticatedRedirect } from "./AuthRedirect";

// Dashboard
const DashboardEcommerce = lazy(() => import("../pages/DashboardEcommerce"));

// Auth inner pages
const BasicPasswCreate = lazy(() => import("../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate"));
const CoverPasswCreate = lazy(() => import("../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate"));
const Offlinepage = lazy(() => import("../pages/AuthenticationInner/Errors/Offlinepage"));

// Authentication
const Login = lazy(() => import("../pages/Authentication/Login"));
const ForgetPasswordPage = lazy(() => import("../pages/Authentication/ForgetPassword"));
const ResetPasswordPage = lazy(() => import("../pages/Authentication/ResetPassword"));
const Logout = lazy(() => import("../pages/Authentication/Logout"));
const Register = lazy(() => import("../pages/Authentication/Register"));
const SelectVendorType = lazy(() => import("../pages/Authentication/SelectVendorType"));
const AffiliateRegister = lazy(() => import("pages/Authentication/Affiliate_Register"));
const AffiliateLogin = lazy(() => import("pages/Authentication/AffiliateLogin"));
const UserProfile = lazy(() => import("../pages/Authentication/user-profile"));
const Settings = lazy(() => import("../pages/Settings/Settings"));

// Landing
const OnePage = lazy(() => import("../pages/Landing/OnePage"));
const NFTLanding = lazy(() => import("../pages/Landing/NFTLanding"));
const JobLanding = lazy(() => import("../pages/Landing/Job"));

// Properties
const PropertyForm = lazy(() => import("pages/Properties/addProperty"));
const Onboarding = lazy(() => import("pages/Properties/Onboarding"));
const DashboardProperties = lazy(() => import("pages/Properties/AllProperty"));
const PendingProperties = lazy(() => import("pages/Properties/pendingApproval.tsx"));
const AllReservations = lazy(() => import("pages/Reservations"));
const AllPayments = lazy(() => import("pages/AllPayments"));
const AllPaymentsStatementsAndInvoices = lazy(() => import("pages/AllPayments/allInvoice"));
const AllRevenueManagement = lazy(() => import("pages/AllRevenue"));

// Property Details
const PropertyDetailHome = lazy(() => import("pages/propertyDetails/Home"));
const RoomsAndRates = lazy(() => import("pages/propertyDetails/Rooms"));
const RoomTypesAndRatePlans = lazy(() => import("pages/propertyDetails/RoomTypes"));
const CancellationPolicies = lazy(() => import("pages/propertyDetails/cancellationPolicy"));
const BulkUpdateRates = lazy(() => import("pages/propertyDetails/Rooms/Bulk-rates"));
const Reservations = lazy(() => import("pages/propertyDetails/reservation"));
const BookingDetail = lazy(() => import("pages/propertyDetails/reservation/detail"));
const Payments = lazy(() => import("pages/propertyDetails/payment"));
const StatementsAndInvoices = lazy(() => import("pages/propertyDetails/payment/allInvoice"));
const PropertyDetails = lazy(() => import("pages/propertyDetails/details"));
const GeneralDetails = lazy(() => import("pages/propertyDetails/details/general"));
const AgreementDetails = lazy(() => import("pages/propertyDetails/details/agreement"));
const PoliciesDetails = lazy(() => import("pages/propertyDetails/details/policies"));
const GuestServicesDetails = lazy(() => import("pages/propertyDetails/details/guestServices"));
const Photos = lazy(() => import("pages/propertyDetails/details/photos"));
const PropertyAmenities = lazy(() => import("pages/propertyDetails/details/propAmenities"));
const RoomAmenities = lazy(() => import("pages/propertyDetails/details/roomAmenities"));
const TaxesFees = lazy(() => import("pages/propertyDetails/details/taxesFees"));
const RevenueManagement = lazy(() => import("pages/propertyDetails/revenueManagement"));

// Affiliate
const Affiliate1 = lazy(() => import("pages/affiliate/affiliate1"));
const DashboardAffiliate = lazy(() => import("pages/affiliate/dashboard/home/home"));
const ConversionsReport = lazy(() => import("pages/affiliate/dashboard/report"));
const CommissionTracking = lazy(() => import("pages/affiliate/dashboard/Commission"));
const PayoutHistory = lazy(() => import("pages/affiliate/dashboard/history"));
const LinkGenerator = lazy(() => import("pages/affiliate/dashboard/link"));
const AffiliateProfile = lazy(() => import("pages/affiliate/dashboard/profile"));


const authProtectedRoutes = [

  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/index", component: <AuthenticatedHomeRedirect /> },

  // Properties
  { path: "/properties/add", component: <PropertyForm /> },
  { path: "/onboarding", component: <Onboarding /> },
  { path: "/allproperties", component: <DashboardProperties /> },
  { path: "/pendingApproval", component: <PendingProperties /> },
  { path: "/allReservations", component: <AllReservations /> },
  { path: "/allPayments", component: <AllPayments /> },
  { path: "/allPayments/allInvoice", component: <AllPaymentsStatementsAndInvoices /> },
  { path: "/allRevenue", component: <AllRevenueManagement /> },

  // Property Details
  { path: "/propertiesDetails/:id", component: <PropertyDetailHome /> },
  { path: "/propertiesDetails/:id/rooms/rates-availability", component: <RoomsAndRates /> },
  { path: "/propertiesDetails/:id/rooms/rates-types", component: <RoomTypesAndRatePlans /> },
  { path: "/propertiesDetails/:id/rooms/cancellation-policies", component: <CancellationPolicies /> },
  { path: "/propertiesDetails/:id/rooms/bulk-rates", component: <BulkUpdateRates /> },
  { path: "/propertiesDetails/:id/reservations", component: <Reservations /> },
  { path: "/propertiesDetails/:id/reservations/:bookingId", component: <BookingDetail /> },
  { path: "/propertiesDetails/:id/payments", component: <Payments /> },
  { path: "/propertiesDetails/:id/payments/allInvoice", component: <StatementsAndInvoices /> },
  { path: "/propertiesDetails/:id/details/overview", component: <PropertyDetails /> },
  { path: "/propertiesDetails/:id/details/general", component: <GeneralDetails /> },
  { path: "/propertiesDetails/:id/details/agreement", component: <AgreementDetails /> },
  { path: "/propertiesDetails/:id/details/policies", component: <PoliciesDetails /> },
  { path: "/propertiesDetails/:id/details/guest-services", component: <GuestServicesDetails /> },
  { path: "/propertiesDetails/:id/details/photos", component: <Photos /> },
  { path: "/propertiesDetails/:id/details/amenities", component: <PropertyAmenities /> },
  { path: "/propertiesDetails/:id/details/room-amenities", component: <RoomAmenities /> },
  { path: "/propertiesDetails/:id/details/taxes-fees", component: <TaxesFees /> },
  { path: "/propertiesDetails/:id/revenue-management", component: <RevenueManagement /> },

  // Affiliate
  { path: "/affiliate/dashboard", component: <DashboardAffiliate /> },
  { path: "/affiliate/report", component: <ConversionsReport /> },
  { path: "/affiliate/commission", component: <CommissionTracking /> },
  { path: "/affiliate/history", component: <PayoutHistory /> },
  { path: "/affiliate/link", component: <LinkGenerator /> },
  { path: "/affiliate/profile", component: <AffiliateProfile /> },

  // User
  { path: "/profile", component: <UserProfile /> },
  { path: "/pages-profile-settings", component: <Settings /> },

  { path: "/", exact: true, component: <AuthenticatedHomeRedirect /> },
  { path: "*", component: <AuthenticatedHomeRedirect /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <AuthenticatedRedirect><Login /></AuthenticatedRedirect> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPasswordPage /> },
  { path: "/register", component: <AuthenticatedRedirect><SelectVendorType /></AuthenticatedRedirect> },
  { path: "/register/form", component: <AuthenticatedRedirect><Register /></AuthenticatedRedirect> },
  { path: "/affiliate_register", component: <AuthenticatedRedirect><AffiliateRegister /></AuthenticatedRedirect> },
  { path: "/affiliate_login", component: <AuthenticatedRedirect><AffiliateLogin /></AuthenticatedRedirect> },

  { path: "/", component: <AuthenticatedRedirect><OnePage /></AuthenticatedRedirect> },
  { path: "/affiliate", component: <Affiliate1 /> },
  { path: "/nft-landing", component: <NFTLanding /> },
  { path: "/job-landing", component: <JobLanding /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },
];

export { authProtectedRoutes, publicRoutes };
